export const buttonVariants = {
  "solid-sm-secondary": {
    borderRadius: "4px",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "600",
    background: "#F56565",
  },
  "solid-lg-secondary": {
    borderRadius: "8px",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: "600",
    background: "#F56565",
  },
  "outlined-sm-secondary": {
    borderRadius: "4px",
    color: "#F56565",
    fontSize: "14px",
    fontWeight: "600",
    border: "1px solid #F56565",
  },
  "outlined-lg-secondary": {
    borderRadius: "8px",
    color: "#F56565",
    fontSize: "14px",
    fontWeight: "600",
    border: "1px solid #F56565",
  },
  "outlined-lg-primary": {
    borderRadius: "8px",
    color: "#000000",
    fontSize: "14px",
    fontWeight: "500",
    border: "solid 1px #000000",
  },
  "outlined-sm-gray": {
    borderRadius: "4px",
    color: "#000000",
    fontSize: "14px",
    fontWeight: "500",
    border: "1px solid #CBD5E0",
  },
  "outlined-md-gray": {
    borderRadius: "8px",
    color: "#000000",
    fontSize: "14px",
    fontWeight: "500",
    border: "1px solid #CBD5E0",
  },
  "outlined-gray-muted": {
    borderRadius: "4px",
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: "12px",
    fontWeight: "500",
    border: "1px solid #CBD5E0",
  },
};
